// Componente per sistema ExeDialog DDT2026 - Step destinazione_pattern e id_dest (trasporto a carico nostro)
import React, { useRef, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ValoriVerificati } from './ValoriVerificati';

export function DestinazionePattern(props) {
    const { onFinish, verificaData } = props;
    const tableRef = useRef();

    const opzioni = verificaData?.opzioni_selezione || [];

    useEffect(() => {
        // Focus
    }, [verificaData]);

    // Seleziona riga dalla tabella
    const handleRowSelect = (e) => {
        const row = e.data;
        onFinish({
            destinazione_pattern: row.destinazione_pattern,
            id_dest: row.id_dest,
            destinazione: row.destinazione
        });
    };

    return (
        <div className="card-body">
            <h5 className="card-title">Commessa Trasporto</h5>
            <p className="text-muted">
                Il trasporto è a carico nostro. Seleziona la destinazione dalla tabella delle commesse trasporto.
            </p>
            
            {opzioni.length === 0 ? (
                <div className="alert alert-warning">
                    Nessuna commessa trasporto disponibile.
                </div>
            ) : (
                <div className="card mb-3">
                <DataTable 
                    ref={tableRef}
                    value={opzioni} 
                    selectionMode="single" 
                    onRowSelect={handleRowSelect}
                    size="small"
                    scrollable
                    scrollHeight="800px"
                    stripedRows
                    header="Commesse Destinazioni"
                >
                    <Column field="destinazione_pattern" header="Commessa Trasporto" sortable />
                    <Column field="destinazione" header="Destinazione" sortable />
                </DataTable>
                </div>
            )}
            
            <ValoriVerificati valori={verificaData?.valori_verificati} />
        </div>
    );
}

DestinazionePattern.displayName = 'destinazione_pattern';
